// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"637":"ce65919e1fcf1614","788":"4ba2606f36b1f454"}[chunkId] + ".js";
};